import React from "react";
import { Button } from "semantic-ui-react";

import Input from "./Input";

export default function NumberSwitchControl({
  onBlur,
  onChange,
  value,
  showCounter = true,
  min,
  max,
  disabled,
  readOnly,
  ...rest
}) {
  const handleClick = (step) => {
    onChange && onChange((value || 0) + step);
    onBlur && onBlur((value || 0) + step);
  };

  return (
    <Button.Group basic className="NumberSwitchControl">
      <Button
        as="a"
        disabled={disabled || readOnly || (min !== undefined && value <= min)}
        onClick={handleClick.bind(null, -1)}
      >
        -
      </Button>
      {showCounter && (
        <Input
          {...rest}
          type="number"
          value={value === null ? "" : value}
          onBlur={onBlur}
          onChange={(nextValue) => onChange(["", null].includes(nextValue) ? null : +nextValue)}
          step="1"
          min={min}
          max={max}
          disabled={disabled}
          readOnly={readOnly}
        />
      )}
      <Button
        as="a"
        disabled={disabled || readOnly || (max !== undefined && value >= max)}
        onClick={handleClick.bind(null, +1)}
      >
        +
      </Button>
    </Button.Group>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/NumberSwitch.jsx